module.exports = __webpack_public_path__ + "static/media/4.35782fb8.jpg";